import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type Location from 'garaje/models/location';
import droppableUpload from 'garaje/utils/decorators/droppable-upload';
import urlBuilder from 'garaje/utils/url-builder';

interface CustomizeCompanyLogoSignature {
  Args: {
    /**
     * Function called after logo is successfully uploaded
     */
    setLogo?: () => void;
    /**
     * The location model whose logo is being customized
     */
    location: Location;
    /**
     * Optional function to expand the welcome image section
     */
    expandWelcomeImage?: () => void;
    /**
     * Optional function to expand the slideshow section
     */
    expandSlideshow?: () => void;
    /**
     * Function to delete the logo (typically a perform() call on a task)
     */
    deleteLogo?: () => void;
    /**
     * Reference to the parent component/controller
     */
    parent?: unknown;
  };
  Element: HTMLDivElement;
}

@droppableUpload
class CustomizeCompanyLogoComponent extends Component<CustomizeCompanyLogoSignature> {
  @tracked isLogoUploading = false;

  get logoUploadUrl(): string {
    return urlBuilder.v2.updateLocationPhotoUrl(this.args.location.id);
  }
}

export default CustomizeCompanyLogoComponent;
